module.exports = __webpack_public_path__ + "img/thumbnail.1a273f1f.png";